// 사진·예약 기록에는 컨셉 이름이 한국어로만 남는다. 화면 언어(영어·일본어)에 맞는 이름은 컨셉 정보에서 찾아 보인다.
// 노출이 끝난 옛 컨셉도 찾도록, 노출 중인 목록이 아니라 이름 검색(/api/concept/select/search)으로 한 이름씩 찾는다.
import axios from "../api/restApi"

const titles = new Map() // 한국어 이름 → { en, jp } (못 찾으면 null)
const pending = new Map()

function fetchTitle(title) {
  if (!pending.has(title)) {
    pending.set(
      title,
      axios
        .post("/api/concept/select/search", { params: { keyword: title } })
        .then((res) => {
          const concept = (Array.isArray(res.data) ? res.data : []).find((item) => item && item.title === title)
          titles.set(title, concept ? { en: concept.title_en || "", jp: concept.title_jp || "" } : null)
        })
        .catch(() => {
          titles.set(title, null)
        })
    )
  }
  return pending.get(title)
}

// 화면에 보일 이름들을 한 번에 불러 둔다. 이미 찾은 이름은 다시 묻지 않는다.
export function loadConceptTitles(list) {
  const missing = [...new Set((list || []).filter((title) => typeof title === "string" && title.trim()))].filter((title) => !titles.has(title))
  return Promise.all(missing.map(fetchTitle))
}

// 앱 언어값(ko / en / jp)에 맞는 이름. 번역이 없으면 한국어 이름 그대로.
export function localizedConceptTitle(title, lang) {
  const found = titles.get(title)
  if (lang === "en") return (found && found.en) || title
  if (lang === "jp") return (found && found.jp) || title
  return title
}
